import { STOCK_TRANSFER_WORKFLOW_TYPE_IDS } from './stock-transfer-workflow.constants';

/** Identifiant transfert LC stocké dans les champs masqués ERP. */
export function extractLogicielCaisseTransfertId(
  doc: unknown,
  erpDocumentId?: number | null
): number | null {
  if (!doc || typeof doc !== 'object') {
    return null;
  }
  const d = doc as Record<string, unknown>;
  const erpIdRaw = erpDocumentId ?? d['id'];
  const erpId = Number(erpIdRaw);
  const rejectIfSameAsErp =
    Number.isFinite(erpId) && erpId > 0 ? erpId : null;
  const full = d['fullData'];
  const sources: unknown[] = [
    d['hidden_client_fields'],
    d['hidden_fournisseur_fields'],
    full && typeof full === 'object'
      ? (full as Record<string, unknown>)['hidden_client_fields']
      : null,
    full && typeof full === 'object'
      ? (full as Record<string, unknown>)['hidden_fournisseur_fields']
      : null,
  ];
  for (const hidden of sources) {
    if (!hidden || typeof hidden !== 'object') {
      continue;
    }
    const h = hidden as Record<string, unknown>;
    const raw =
      h['logiciel_caisse_transfert_id'] ?? h['stock_transfert_id'] ?? h['lc_transfert_id'];
    const n = Number(raw);
    if (Number.isFinite(n) && n > 0) {
      if (rejectIfSameAsErp != null && n === rejectIfSameAsErp) {
        continue;
      }
      return n;
    }
  }
  return null;
}

export function isBonReceptionDocumentFromLogicielCaisse(doc: unknown): boolean {
  if (!doc || typeof doc !== 'object') {
    return false;
  }
  const d = doc as Record<string, unknown>;
  const typeDoc = d['typeDocument'] as Record<string, unknown> | undefined;
  const typeDocAlt = d['type_document'] as Record<string, unknown> | undefined;
  const typeId = Number(d['type_document_id'] ?? typeDoc?.['id'] ?? typeDocAlt?.['id']);
  const titre = String(typeDoc?.['titre'] ?? typeDocAlt?.['titre'] ?? '')
    .toUpperCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
  const isBr =
    typeId === STOCK_TRANSFER_WORKFLOW_TYPE_IDS.BON_RECEPTION ||
    titre.includes('BON') && titre.includes('RECEPTION');
  if (!isBr) {
    return false;
  }
  return extractLogicielCaisseTransfertId(doc) != null;
}
